"use strict";

const init = (elem) => {
    const firstLevelNavigation = [].slice.call(document.querySelectorAll(".js-first-level"));
    if (!window.mqRespond.status.lgDown) {
        firstLevelNavigation.forEach(menuItem => {
            menuItem.addEventListener("mouseenter", () => {
                if (elem) {
                    elem.blur();
                }
            });
        });
    }
};

module.exports = {
    init: init
};
